import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AppLayoutDoctor from "../../../navigation/Layout/LayoutDoctor";
import { getCurrentDoctor } from "../../../authDoctor/redux/thunks/doctorsThunks";
import { selectDoctorProfile } from "../../../authDoctor/redux/selectors/doctorsSelectors";
import PaymentBoard from "../../components/PaymentBoard/PaymentBoard";
import { DOCTOR_PLANS } from "../../config/plans.config";

export default function PlansDoctor() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const doctor = useSelector(selectDoctorProfile);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    dispatch(getCurrentDoctor());
  }, [dispatch]);

  const userId = doctor?.id || null;

  return (
    <AppLayoutDoctor>
      <PaymentBoard
        plans={DOCTOR_PLANS}
        userId={userId}
        userType="doctor"
        title={t("payment.pages.doctor.title")}
        subtitle={t("payment.pages.doctor.subtitle")}
      />
    </AppLayoutDoctor>
  );
}